import React from 'react';

/*eslint-disable */

String.prototype.format = function(args = {}) {
  return this.replace(/%\(([a-zA-Z]+)\)s/g, (str, match) => {
    return typeof args[match] === 'undefined' ? str : args[match];
  });
};

/*eslint-enable */

export const formatNumber = (n, c = 2, d = ',', t = ' ') => {
  const s = n < 0 ? '-' : '';
  const i = parseInt((n = Math.abs(+n || 0).toFixed(c)), 10) + '';
  let j;
  j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
};

export const formatPrice = (
  n,
  currency = 'EUR',
  c = 2,
  d = ',',
  t = '\u00a0',
) => {
  return (
    formatNumber(n, c, d, t, c) + (currency === 'EUR' ? ' €' : ` ${currency}`)
  );
};

export const guid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
};

export const parsePlaylistItem = itemTitle => {
  // Specialny pripad
  const specialnePripady = [
    'Dopravny servis Radia Kosice',
    'Pre reklamu v Radiu Kosice volajte',
  ];
  for (const sp of specialnePripady) {
    if (itemTitle.includes(sp)) {
      return [sp, itemTitle.substr(sp.length)];
    }
  }

  // // Specialny pripad 2
  // const reklama = 'Pre reklamu v Radiu Kosice volajte';
  // if (itemTitle.includes(reklama)) {
  //   return [dopravnyServis, itemTitle.substr(dopravnyServis.length)];
  // }

  // Inak rozdelujeme podla "-"
  const delimiter = ' - ';
  let idx = itemTitle.indexOf(delimiter);
  if (idx !== -1) {
    return [itemTitle.substr(0, idx), itemTitle.substr(idx + delimiter.length)];
  }

  // Nevieme to rozumne rozdelit
  return [itemTitle, null];
};

export const dataBaseUrl = () => {
  return 'https://data.tvkosice.sk/cmdata';
};

export const imageCropBaseUrl = (
  left = 0,
  top = 0,
  width = 0,
  height = 0,
  resize_w = 0,
  resize_h = 0,
) => {
  if (resize_w > 0 || resize_h > 0) {
    return `https://data.tvkosice.sk/images/cm/${left}x${top}x${width}x${height}x${resize_w}x${resize_h}`;
  } else {
    return `https://data.tvkosice.sk/images/cm/${left}x${top}x${width}x${height}`;
  }
};

export const imageResizeBaseUrl = (
  width = 0,
  height = 0,
  imageBaseUrl = null,
) => {
  const base = imageBaseUrl || 'https://data.tvkosice.sk/images/cm/';
  return `${base}${width}x${height}xresize`;
};

export const staticImageBaseUrl = img => {
  return `https://data.tvkosice.sk/static/${img}`;
};

export const imageBaseUrl = (width = 0, height = 0) => {
  return `https://data.tvkosice.sk/images/${width}x${height}xresize`;
};

export const nl2br = (str, is_xhtml = true) => {
  let breakTag = is_xhtml ? '<br />' : '<br>';
  return (str + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2',
  );
};

export const nl2p = str => {
  const regex = new RegExp(/(.+\n|.+$)/, 'g');
  return str.replace(regex, '<p>$1</p>');
};

export const trimSlashes = str => {
  return str.replace(/^\/|\/$/g, '');
};

export const calendarTime = (momentTime, uppercase = true) => {
  let creationDate = momentTime.calendar(null, {
    sameDay: '[Dnes]',
    nextDay: '[Zajtra]',
    nextWeek: 'dddd',
    lastDay: '[Včera]',
    lastWeek: 'DD.MM.YYYY',
    sameElse: 'DD.MM.YYYY',
  });
  if (uppercase) {
    creationDate = creationDate.toLocaleUpperCase();
  }
  return `${creationDate} | ${momentTime.format('H:mm')}`;
};

export const calendarTimeStylized = momentTime => {
  let creationDate = momentTime.calendar(null, {
    sameDay: '[Dnes]',
    nextDay: '[Zajtra]',
    nextWeek: 'dddd',
    lastDay: '[Včera]',
    lastWeek: 'DD.MM.YYYY',
    sameElse: 'DD.MM.YYYY',
  });
  creationDate = creationDate.toLocaleUpperCase();
  return (
    <span>
      {' '}
      {creationDate} |{' '}
      <span className="text-primary"> {momentTime.format('H:mm')} </span>
    </span>
  );
};

export const transformTvKosiceVideoToStandardArticle = tvKosiceVideo => {
  let id = tvKosiceVideo.id;
  if (!id) {
    id = tvKosiceVideo._id;
  }
  return {
    name: tvKosiceVideo.title,
    date: tvKosiceVideo.publish_from,
    created: tvKosiceVideo.created_date,
    picture: {
      uri: getProp(tvKosiceVideo, 'thumbnail', null),
    },
    section: {
      name: getProp(tvKosiceVideo, 'category_name', ''),
    },
    original: tvKosiceVideo,
    url: `video/${id}`,
  };
};

export const generateArticleUrl = article => {
  let url = `/clanok/${article._id}`;
  if (article.url) {
    url = `/${trimSlashes(article.url)}`;
  }
  return url;
};

export const __ = toTranslate => {
  return toTranslate;
};

export const getProp = (object, path, defaultValue = '') => {
  const val = path.split('.').reduce(function(o, x) {
    return typeof o === 'undefined' || o === null ? defaultValue : o[x];
  }, object);
  if (typeof val === 'undefined') {
    return defaultValue;
  }
  return val;
};



// WEBPACK FOOTER //
// ./src/ui/src/utilities.js